module.exports = __webpack_public_path__ + "8147f7cb676f1cc099976bf87912f6ac.svg";